import { RestaurantDetails_getRestaurantDetails } from '../types/graphql-types-generated.ts';

export const hasReservation = (
  restaurantDetails: RestaurantDetails_getRestaurantDetails
): boolean => {
  return true;
  // const hasPartnerSettingsLivebookings = restaurantDetails.partnerSettingsQuandoo?.id != null;
  // const hasPartnerSettingsQuandoo = restaurantDetails.partnerSettingsOpentable?.id != null;
  // const hasPartnerSettingsOpentable = restaurantDetails.partnerSettingsLivebooking?.id != null;
  // const hasTableBooking = restaurantDetails.hasTableBooking ?? false;

  // return (
  //   hasPartnerSettingsLivebookings ||
  //   hasPartnerSettingsQuandoo ||
  //   hasPartnerSettingsOpentable ||
  //   hasTableBooking
  // );
};
